// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Card from "../../components/Card"
import LabeledValue from "../../components/LabeledValue"
import { withRouter } from "react-router-dom"
import Input from "react-toolbox/lib/input/Input"
import _ from "lodash"
import * as strings from "../../strings"
import * as utils from "../../utils"


class PreLitigationDetails extends Component {
  props: {
    onChange: () => any,
    preLitigation: any,
    history: any,
    token: any,
  }


  handleChange = ( name, isToRound ) => value => this.props.onChange && this.props.onChange( {
    ...this.props.preLitigation,
    [ name ]: !_.isEqual( value, "" ) ? isToRound ? _.round( value, 2 ) : value : null,
  } )

  render () {
    const { preLitigation } = this.props
    console.log(preLitigation)
    return (
      <div className={style.root}>
        <div className={style.row}>
        </div>
        <Card decor className={style.bottomCard}>
          <div className={style.preLitigationDetailsGrid}>
            <LabeledValue label={strings.execution.capitalValue}>
              {utils.formatCurrency(preLitigation.capitalValue)}
            </LabeledValue>
            <Input
              label={strings.generalStrings.idc}
              value={preLitigation.idc}
              onChange={this.handleChange( "idc", false )}
              type="text"
              step="0.01"
              min="0.00"
            />
            <Input
              label="Juros"
              value={preLitigation.interest}
              onChange={this.handleChange( "interest", false )}
              type="text"
              step="0.01"
              min="0.00"
            />
          </div>
        </Card>
      </div>
    )
  }
}

export default withRouter( PreLitigationDetails )



// WEBPACK FOOTER //
// ./src/components/PreLitigationDetails/index.jsx